import React from "react";
import ImageCarousel from "../../assets/ImageCarousel";
import { useDeviceSize, MOBILE } from "../../assets/hooks/useDeviceSize";
import ProductConfigurer from "./ProductConfigurer";
import { useState } from "react";
import ProductSelector from "./ProductSelector";
import { SwitchTransition, CSSTransition } from "react-transition-group";

/**
 * Product info is the contentr used inside the modal window when clicking on a product.
 * It shows details of the product such as images, name, description and ability to add
 * to basket.
 * 
 * Also shows product variants, and allows adding of those. 
 */

export default function ProductInfo({
	product,
	variants = [],
	featureColor = "#000000"
}) {

	const { device } = useDeviceSize();

	// Handle whether the product is being configured, and which product.
	const [configuring, setConfiguring] = useState(null);
	const pictureSet = (product.images || []);

	return <div className="product-info" style={{
		backgroundColor: featureColor,
		...(!pictureSet.length ? { paddingTop: 20 } : {})
	}}>
		{/* Images */}
		{Boolean(pictureSet.length) && <ImageCarousel
			images={pictureSet}
			style={{
				height: device === MOBILE ? "100vw" : 550
			}}
		/>}
		<SwitchTransition>
			<CSSTransition
				key={configuring ? "configure" : "select"}
				timeout={300}
				classNames="sideFade"
			>
				<div className="lower sideFader" style={{
					marginRight: device === MOBILE ? 10 : 20,
					marginLeft: device === MOBILE ? 10 : 20,
					marginTop: pictureSet.length ? -70 : undefined
				}}>
					{configuring ?
						(
							<ProductConfigurer
								product={configuring}
								featureColor={featureColor}
								onCancel={() => setConfiguring(null)}
							/>
						) : (
							<ProductSelector
								product={product}
								variants={variants}
								featureColor={featureColor}
								onStartConfiguring={setConfiguring}
							/>
						)
					}
				</div>
			</CSSTransition>
		</SwitchTransition>
	</div>
}
